// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wa_a bhj_b","TwoDimsListFeature__item":"wa_b bhj_wb","TwoDimsListFeature__item__text":"wa_c bhj_vr"};